import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { usePriceDisplay } from '../hooks/usePriceDisplay';
export function StickyAlertBar() {
  const originalPrice = usePriceDisplay(49.99);
  const discountedPrice = usePriceDisplay(16.99);
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-950/95 backdrop-blur-md border-t border-orange-500/30 px-4 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]" data-id="element-148">
      <div className="max-w-xl mx-auto flex items-center gap-3" data-id="element-149">
        <div className="flex flex-col flex-shrink-0" data-id="element-150">
          <span className="text-slate-500 line-through text-xs font-medium" data-id="element-151">
            {'ARS\xA0$30.990'}
          </span>
          <span className="text-white font-bold text-lg leading-tight" data-id="element-152">
            {'ARS\xA0$14.990'}
          </span>
        </div>
        <a href="https://carlosconte.com/cart" className="flex-1 flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-500 text-white font-heading font-bold text-sm md:text-base uppercase tracking-wide py-3 px-4 rounded-lg transition-all duration-200 hover:scale-[1.02]" data-id="element-153">
          <ShoppingCart className="w-4 h-4" data-id="element-154" />
          ¡QUIERO MI CAMBIO!
        </a>
      </div>
    </div>;
}